module.exports = __webpack_public_path__ + "media/landing-page/bg-hero-2-min-ad5e1a6e.svg";